(() => {
  const revealPolicyPage = () => document.documentElement.classList.remove('policy-page-pending');

  const nativePolicy = document.querySelector('.shopify-policy__container');
  const standardPolicyPage = document.querySelector('.cc-main-page .container');
  const container = nativePolicy || standardPolicyPage;
  const title = nativePolicy
    ? container?.querySelector('.shopify-policy__title')
    : container?.querySelector('.page__title')?.parentElement;
  const body = nativePolicy
    ? container?.querySelector('.shopify-policy__body')
    : container?.querySelector('.page__content');

  if (!container || !title || !body) {
    revealPolicyPage();
    return;
  }

  let content = body.querySelector('.rte');
  if (!nativePolicy) {
    content = document.createElement('div');
    content.className = 'rte';
    while (body.firstChild) content.append(body.firstChild);
    body.append(content);
    body.classList.remove('rte');
    title.classList.remove('rte');
  }
  if (!content) {
    revealPolicyPage();
    return;
  }

  formatPolicyTitle(title.querySelector('h1'));
  container.classList.add('shopify-policy__container');
  title.classList.add('shopify-policy__title');
  body.classList.add('shopify-policy__body');

  const strings = {
    toc: window.theme?.strings?.tableOfContents || 'On this page',
    backToTop: window.theme?.strings?.backToTop || 'Back to top',
    backToPolicies: window.theme?.strings?.backToPolicies || 'Back to policies',
    close: window.theme?.strings?.close || 'Close'
  };
  const headings = [...content.querySelectorAll('h2, h3, h4')]
    .filter((heading) => heading.textContent.trim());

  title.id = title.id || 'PolicyPageTop';
  addBackToPoliciesLink();
  wrapTables(content);
  body.prepend(title);
  container.classList.add('policy-page--enhanced');

  const layout = document.createElement('div');
  layout.className = 'policy-layout';
  body.before(layout);
  layout.append(body);

  if (!headings.length) {
    revealPolicyPage();
    return;
  }

  const usedIds = new Set();
  headings.forEach((heading, index) => {
    heading.id = uniqueHeadingId(heading, index, usedIds);
    heading.classList.add('policy-toc-target');
  });

  layout.append(buildDesktopNavigation());
  title.after(buildMobileNavigation());
  revealPolicyPage();

  const mobileToc = container.querySelector('[data-policy-mobile-toc]');
  const mobilePanel = container.querySelector('[data-policy-mobile-panel]');
  const mobileTrigger = container.querySelector('[data-policy-mobile-trigger]');
  let closeTimer;
  let scrollFrame;
  let activeHeadingId;

  container.addEventListener('click', (event) => {
    const link = event.target.closest('[data-policy-toc-link], [data-policy-back-to-top]');
    if (link) {
      event.preventDefault();
      navigateTo(link.hash);
      closeMobileToc();
      return;
    }

    if (event.target.closest('[data-policy-mobile-trigger]')) {
      mobileTrigger.getAttribute('aria-expanded') === 'true' ? closeMobileToc() : openMobileToc();
      return;
    }

    if (event.target.closest('[data-policy-mobile-close]')) closeMobileToc(true);
  });

  document.addEventListener('click', (event) => {
    if (mobileTrigger.getAttribute('aria-expanded') === 'true' && !mobileToc.contains(event.target)) {
      closeMobileToc();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && mobileTrigger.getAttribute('aria-expanded') === 'true') {
      closeMobileToc(true);
    }
  });

  window.addEventListener('scroll', requestActiveUpdate, { passive: true });
  window.addEventListener('resize', requestActiveUpdate, { passive: true });
  updateActiveHeading();

  function buildDesktopNavigation() {
    const aside = document.createElement('aside');
    aside.className = 'policy-sidebar';
    aside.setAttribute('aria-label', strings.toc);
    aside.innerHTML = `
      <div class="policy-sidebar__sticky">
        <nav class="policy-toc" aria-labelledby="PolicyTocHeading">
          <h2 class="policy-toc__heading h6" id="PolicyTocHeading">${escapeHtml(strings.toc)}</h2>
          <div class="policy-toc__scroll">${buildList()}</div>
        </nav>
        ${backToTopMarkup()}
      </div>`;
    return aside;
  }

  function addBackToPoliciesLink() {
    if (title.querySelector('.policy-back-link')) return;

    const link = document.createElement('a');
    link.className = 'policy-back-link';
    link.href = window.theme?.routes?.policyHub || '/pages/knowledge-hub#knowledge-hub-policies';
    link.innerHTML = `<svg viewBox="0 0 20 20" aria-hidden="true"><path d="m12.5 5-5 5 5 5"></path></svg><span>${escapeHtml(strings.backToPolicies)}</span>`;
    title.prepend(link);
  }

  function buildMobileNavigation() {
    const navigation = document.createElement('div');
    navigation.className = 'policy-toc-mobile';
    navigation.dataset.policyMobileToc = '';
    navigation.innerHTML = `
      <button class="policy-toc-mobile__trigger" type="button" data-policy-mobile-trigger aria-expanded="false" aria-controls="PolicyTocMobilePanel">
        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 6h11M9 12h11M9 18h11"></path><circle cx="4" cy="6" r="1"></circle><circle cx="4" cy="12" r="1"></circle><circle cx="4" cy="18" r="1"></circle></svg>
        <span>${escapeHtml(strings.toc)}</span>
        <svg class="policy-toc-mobile__chevron" viewBox="0 0 20 20" aria-hidden="true"><path d="m5 7.5 5 5 5-5"></path></svg>
      </button>
      <div class="policy-toc-mobile__panel" id="PolicyTocMobilePanel" data-policy-mobile-panel hidden>
        <div class="policy-toc-mobile__header">
          <h2 class="h6">${escapeHtml(strings.toc)}</h2>
          <button class="policy-toc-mobile__close" type="button" data-policy-mobile-close aria-label="${escapeHtml(strings.close)}">
            <svg viewBox="0 0 20 20" aria-hidden="true"><path d="m5 5 10 10M15 5 5 15"></path></svg>
          </button>
        </div>
        <div class="policy-toc-mobile__scroll">${buildList()}</div>
        ${backToTopMarkup()}
      </div>`;
    return navigation;
  }

  function buildList() {
    const items = headings.map((heading) => {
      const level = heading.tagName.toLowerCase();
      return `<li class="policy-toc__item policy-toc__item--${level}"><a class="policy-toc__link" href="#${encodeURIComponent(heading.id)}" data-policy-toc-link>${escapeHtml(heading.textContent.trim())}</a></li>`;
    }).join('');
    return `<ol class="policy-toc__list">${items}</ol>`;
  }

  function backToTopMarkup() {
    return `<a class="policy-back-to-top" href="#${title.id}" data-policy-back-to-top><svg viewBox="0 0 20 20" aria-hidden="true"><path d="m5 12 5-5 5 5"></path></svg><span>${escapeHtml(strings.backToTop)}</span></a>`;
  }

  function openMobileToc() {
    if (closeTimer) clearTimeout(closeTimer);
    mobilePanel.hidden = false;
    mobileTrigger.setAttribute('aria-expanded', 'true');
    requestAnimationFrame(() => {
      mobileToc.classList.add('is-open');
      keepActiveTocLinksInView();
    });
  }

  function closeMobileToc(restoreFocus = false) {
    mobileToc.classList.remove('is-open');
    mobileTrigger.setAttribute('aria-expanded', 'false');
    closeTimer = setTimeout(() => { mobilePanel.hidden = true; }, 180);
    if (restoreFocus) mobileTrigger.focus();
  }

  function navigateTo(hash) {
    const target = document.getElementById(decodeURIComponent(hash.slice(1)));
    if (!target) return;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    history.pushState(null, '', `#${encodeURIComponent(target.id)}`);
    if (target.matches('h1, h2, h3, h4, h5, h6')) {
      target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
    }
  }

  function requestActiveUpdate() {
    if (scrollFrame) return;
    scrollFrame = requestAnimationFrame(() => {
      updateActiveHeading();
      scrollFrame = null;
    });
  }

  function updateActiveHeading() {
    const headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
    const activationPoint = headerHeight + 48;
    let activeHeading = headings[0];

    headings.forEach((heading) => {
      if (heading.getBoundingClientRect().top <= activationPoint) activeHeading = heading;
    });

    const activeHeadingChanged = activeHeadingId !== activeHeading.id;
    activeHeadingId = activeHeading.id;

    container.querySelectorAll('[data-policy-toc-link]').forEach((link) => {
      const active = decodeURIComponent(link.hash.slice(1)) === activeHeading.id;
      link.classList.toggle('is-active', active);
      active ? link.setAttribute('aria-current', 'location') : link.removeAttribute('aria-current');
    });

    if (activeHeadingChanged) keepActiveTocLinksInView();
  }

  function keepActiveTocLinksInView() {
    container.querySelectorAll('[data-policy-toc-link].is-active').forEach((link) => {
      const scrollContainer = link.closest('.policy-toc__scroll, .policy-toc-mobile__scroll');
      if (!scrollContainer || scrollContainer.clientHeight === 0) return;

      const containerRect = scrollContainer.getBoundingClientRect();
      const linkRect = link.getBoundingClientRect();
      const edgePadding = 8;

      if (linkRect.top < containerRect.top + edgePadding) {
        scrollContainer.scrollTop -= containerRect.top + edgePadding - linkRect.top;
      } else if (linkRect.bottom > containerRect.bottom - edgePadding) {
        scrollContainer.scrollTop += linkRect.bottom - containerRect.bottom + edgePadding;
      }
    });
  }

  function uniqueHeadingId(heading, index, ids) {
    const existing = heading.id.trim();
    let base = existing || heading.textContent.trim().toLowerCase().normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '');
    if (!base) base = `policy-section-${index + 1}`;

    let id = base;
    let suffix = 2;
    while (ids.has(id) || (document.getElementById(id) && document.getElementById(id) !== heading)) {
      id = `${base}-${suffix}`;
      suffix += 1;
    }
    ids.add(id);
    return id;
  }

  function wrapTables(scope) {
    scope.querySelectorAll('table').forEach((table) => {
      if (table.parentElement?.classList.contains('policy-table-scroll')) return;
      if (table.parentElement?.classList.contains('scrollable-table')) {
        table.parentElement.classList.add('policy-table-scroll');
        table.parentElement.setAttribute('tabindex', '0');
        return;
      }
      const wrapper = document.createElement('div');
      wrapper.className = 'policy-table-scroll';
      wrapper.setAttribute('tabindex', '0');
      table.before(wrapper);
      wrapper.append(table);
    });
  }

  function escapeHtml(value) {
    const element = document.createElement('span');
    element.textContent = value;
    return element.innerHTML;
  }

  function formatPolicyTitle(heading) {
    if (!heading) return;

    const minorWords = new Set(['a', 'an', 'and', 'as', 'at', 'but', 'by', 'for', 'in', 'nor', 'of', 'on', 'or', 'per', 'the', 'to', 'via']);
    const words = heading.textContent.trim().split(/(\s+)/);
    const wordIndexes = words
      .map((word, index) => (/\S/.test(word) ? index : null))
      .filter((index) => index !== null);

    words.forEach((word, index) => {
      if (!/\S/.test(word)) return;

      const isFirstOrLast = index === wordIndexes[0] || index === wordIndexes[wordIndexes.length - 1];
      const normalizedWord = word.toLowerCase();
      words[index] = !isFirstOrLast && minorWords.has(normalizedWord)
        ? normalizedWord
        : normalizedWord.charAt(0).toUpperCase() + normalizedWord.slice(1);
    });

    heading.textContent = words.join('');
  }
})();
